module.exports = __webpack_public_path__ + "d52a7b9d679f23c7ec7c90a74a38d5fe.MP3";